import { useEffect, useCallback, useState } from "react";
import "./App.css";
import {
  useAccount,
  useSignMessage,
  useDisconnect,
  useConnect,
  useEnsName,
} from "wagmi";
import { injected } from "wagmi/connectors";
import {
  Address,
  Authorization,
  AuthorizationPrivilege,
  AuthorizeEventType,
  ChainId,
  Client,
  ClientPayload,
  DataType,
  MemberMessageEventType,
  Message,
  RESTProvider,
  SignatureData,
  SubscriberRole,
  Subscription,
  SubscriptionStatus,
  Utils,
} from "@mlayerprotocol/core/browser";
import { Buffer } from "buffer";

import {
  KEYPAIR_STORAGE_KEY,
  ML_CHAIN_ID,
  NODE_HTTP,
  SUBNET_ID,
  TOPIC_ID,
  VALIDATOR_PUBLIC_KEY,
} from "./constant.d";
import { ToastContainer, toast } from "react-toastify";
import { wagmiConfig, wagmiProjectId } from "./wagmi.config.";
import { createWeb3Modal } from "@web3modal/wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";

interface Props {
  children: any;
}

function App(props: Props) {
  const { address } = useAccount();

  const { open, close } = useWeb3Modal();

  // });
  const { disconnect } = useDisconnect();
  const { signMessage } = useSignMessage();

  const [loading, setLoading] = useState(false);
  const [localAgentRecords, setLocalAgentRecords] = useState<
    Record<string, AddressData>
  >({});

  const { data, error, status } = useEnsName({ address });

  const subscribeAccount = async (
    account: string,
    agent: AddressData,
    client: Client<unknown>
  ) => {
    const subscriptions = await client.getAccountSubscriptions({
      params: {
        top: TOPIC_ID,
        sub: Address.fromString(account).toAddressString(),
        snet: SUBNET_ID,
      },
    });
    // console.log("SUBSCRIPTIONS", subscriptions); //
    if (
      !subscriptions?.data ||
      (Array.isArray(subscriptions?.data) && subscriptions?.data?.length == 0)
    ) {
      const subscriptionPayload = Subscription.newSubscriptionPayload({
        account: Address.fromString(account),
        subscriber: Address.fromString(account),
        topic: TOPIC_ID,
        status: SubscriptionStatus.Subscribed,
        role: SubscriberRole.Writer,
        subnet: SUBNET_ID,
      });
      const signed = subscriptionPayload.sign({
        chainId: ML_CHAIN_ID,
        agentPrivateKey: agent.privateKey,
        validator: String(VALIDATOR_PUBLIC_KEY),
      });
      try {
        const subResp: any = await client.createSubscription(signed);
      } catch (e: any) {
        clearAgent(account)
        await generateAgent()
        console.log("createSubscriptionError", e.response?.data?.error)
      }
    }
  };

  useEffect(() => {
    if (address == null) {
      return;
    }
    generateAgent();
    // window.localStorage.removeItem(KEYPAIR_STORAGE_KEY);
  }, [address]);
  useEffect(() => {
    console.log({
      data,
      error,
      status,
      address,
      localAgentRecords,
      NODE_HTTP,
      VALIDATOR_PUBLIC_KEY,
    });
  }, [data, error, status, address, localAgentRecords]);

  useEffect(() => {
    window.Buffer = Buffer;
    (window as any).sendGameMessage = sendGameMessage;
    if (localAgentRecords[String(address)]?.authData) {
      const client = new Client(new RESTProvider(NODE_HTTP));
      setTimeout(() => {
        console.log(
          "HELOOOOOOOOOO",
          address,
          localAgentRecords[String(address)],
          localAgentRecords[String(address)].address
        );
        subscribeAccount(
          String(address),
          localAgentRecords[`${address}`],
          client
        ).then();
      }, 2000);
    }
  }, [address, localAgentRecords]);

  function clearAgent(address: string) {
    const localString = window.localStorage.getItem(KEYPAIR_STORAGE_KEY);
    if (localString?.length) {
      let localData: Record<string, AddressData> = {};
      try {
        localData = JSON.parse(localString) ?? {};
      } catch (error) { }
      if (localData[`${address}`]?.authData != null) {
        localData[`${address}`].authData = undefined;
        setLocalAgentRecords(localData);
       
      }
      window.localStorage.setItem(KEYPAIR_STORAGE_KEY, JSON.stringify(localData))
    }
  }

  const connectFn = async () => {

    open()
      .then(() => {
        setTimeout(() => {
          try {
            const w3modal: any = document.querySelector("w3m-modal");
            const nn = w3modal.shadowRoot.querySelector("wui-card");
            const oo = nn.querySelector("w3m-router").shadowRoot;
            const pp = oo.querySelector("w3m-connect-view").shadowRoot;
            const emailLoginWidget = pp.querySelector("w3m-email-login-widget");
            const socialLoginWidget = pp.querySelector(
              "w3m-social-login-widget"
            );
            // const form = pp.querySelector("form");
            emailLoginWidget.style.display = "none";
            socialLoginWidget.style.display = "none";
          } catch (error) {
            console.log({ error });
          }
        }, 100);
      })
      .catch((err) => {
        console.error("Failed to connect wallet", err);
        toast.error("Failed to connect wallet");
      });

  };

  const disconnectFn = async () => {
    await disconnect();
  };

  const sendGameMessage = useCallback(
    async (message: string) => {
      console.log({ message, address, localAgentRecords });
      if (!address) {
        toast("Please connect wallet");
        return;
      }
      if (!localAgentRecords[address]) {
        toast("No active agent");
        return;
      }
      await sendMessage(message, localAgentRecords[address]);

      // const ensName = await getEnsName(config, { address })
    },
    [address, localAgentRecords]
  );

  const generateAgent = useCallback(async () => {
    const localString = window.localStorage.getItem(KEYPAIR_STORAGE_KEY);
    if (localString != null) {
      let localData: Record<string, AddressData> = {};
      try {
        localData = JSON.parse(localString) ?? {};
      } catch (error) {}
      if (localData[`${address}`]?.authData != null) {
        setLocalAgentRecords(localData);
        return localData[`${address}`];
      }
    }
  

    const keyPair = Utils.generateKeyPairEcc() as AddressData;
   
    setLocalAgentRecords((old) => {
      console.log({ generateAgent: keyPair });
      const newVal = { ...old, [`${address}`]: keyPair };
      window.localStorage.setItem(KEYPAIR_STORAGE_KEY, JSON.stringify(newVal));
      return newVal;
    });
    return keyPair;
  }, [address]);

  const handleAuth = useCallback(async () => {
   let keyPair = localAgentRecords[`${address}`]
    if (keyPair == null) {
      keyPair =  await generateAgent();
      await new Promise((r) => {
        setTimeout(r, 1000)
      })
    } else {

    }
    console.log("AGGEENTLSSD", address,  keyPair)
    setLoading(true);
    await authorizeAgent?.(
      keyPair,
      30,
      AuthorizationPrivilege.Member,
      SUBNET_ID
    ).then((o) => {});
    setLoading(false);
  }, [address, localAgentRecords]);

  const authorizeAgent = async (
    agent: AddressData,
    days: number = 0,
    privilege: AuthorizationPrivilege = AuthorizationPrivilege.Member,
    subnetId: string
  ) => {
    const account = address;
    if (account == null) {
      toast("No account found");
      return;
    }
    // Loader
    await generateAuthorizationMessage(
      {
        address: account,
        publicKey: account,
        privateKey: "",
      } as AddressData,
      agent,
      days,
      privilege,
      subnetId
    )
      .then(async (authority) => {
        console.log({ authority });
        const payload: ClientPayload<Authorization> = new ClientPayload();
        payload.data = authority;
        payload.timestamp = Date.now();
        payload.eventType = AuthorizeEventType.AuthorizeEvent;
        payload.validator = String(VALIDATOR_PUBLIC_KEY);
        const pb = payload.encodeBytes();
        console.log(
          "AUTHORITY_HASH",
          Utils.keccak256Hash(authority.encodeBytes()).toString("hex")
        );
        const hash = Utils.keccak256Hash(pb).toString("base64");

        const message = JSON.stringify({
          action: `write_authorization`,
          identifier: `${authority.agent.address}`,
          network: ML_CHAIN_ID,
          hash: `${hash}`,
        }).replace(/\\s+/g, "");

        const signatureRespEth = await signEth(message, String(address));
        authority.signatureData = new SignatureData(
          "eth",
          signatureRespEth.variables.account,
          signatureRespEth.data ?? ""
        );
        // console.log("NODEAPI", NODE_HTTP);
        const client = new Client(new RESTProvider(NODE_HTTP));
        client
          .authorize(payload)
          .then(async (ev: any) => {
            console.log({ ev });
            const event = ev?.data?.event;

            client
              .resolveEvent({ type: event?.t, id: event?.id })
              .then(async (e) => {
                console.log({ e });

                //  await subscribeAccount(account, agent, client);

                const localString =
                  window.localStorage.getItem(KEYPAIR_STORAGE_KEY);
                if (localString == null) return;

                let localAgentRecords: Record<string, AddressData> =
                  JSON.parse(localString);
                const lAgent: AddressData = localAgentRecords[`${address}`];
                lAgent.authData = {
                  ts: authority.timestamp,
                  du: authority.duration,
                  sigD: authority.signatureData,
                  acct: String(authority.account),
                } as AuthenticationData;
                localAgentRecords = {
                  ...localAgentRecords,
                  [`${address}`]: lAgent,
                };
                window.localStorage.setItem(
                  KEYPAIR_STORAGE_KEY,
                  JSON.stringify(localAgentRecords)
                );
                setLocalAgentRecords(localAgentRecords);
              });
          })
          .finally(() => {
            // Loader
          });
      })
      .catch((r) => {
        console.log({ r });
        // setLoading(false);
        // Loader
      });
  };

  const generateAuthorizationMessage = async (
    account: AddressData,
    agent: AddressData,
    days: number = 30,
    privilege: AuthorizationPrivilege,
    subnetId: string
  ) => {
    if (subnetId == null) {
      toast("No Subnet Selected");
      throw Error("No Subnet Selected");
      // return;
    }
    const authority: Authorization = new Authorization();
    // console.log("keypairsss", Utils.generateKeyPairSecp());
    // console.log(
    //   "BECH32ADDRESS",
    //   validatorPublicKey,
    //   Utils.toAddress(Buffer.from(validatorPublicKey, "hex"))
    // );
    console.log("AGENTTTTTTT", agent);
    authority.account = Address.fromString(account.publicKey);
    authority.agent = Address.fromString(agent.address);
    authority.grantor = Address.fromString(account.address);
    authority.timestamp = Date.now();
    authority.topicIds = "*";
    authority.privilege = privilege;
    authority.subnet = subnetId;
    authority.duration = days * 24 * 60 * 60 * 1000; // 30 days
    // console.log({ authority });
    const encoded = authority.encodeBytes();
    // console.log("ID::::", { authority, encoded });

    return authority;
  };

  const signEth: (
    message: string | { raw: `0x${string}` },
    signer: string
  ) => Promise<{
    data?: string;
    error?: string;
    variables: any;
    context: any;
  }> = async (message: string | { raw: `0x${string}` }, signer: any) => {
    return new Promise<{
      data?: string;
      error?: string;
      variables: any;
      context: any;
    }>((resolve, reject) => {
      signMessage(
        { message: message, account: signer },
        {
          onSuccess(data, variables, context) {
            resolve({ data: data, variables, context });
          },
          onError(error, variables, context) {
            reject({ error, variables, context });
          },
        }
      );
    });
  };

  const sendMessage = async (messageString: string, agent: AddressData) => {
    const account = address;
    if (account == null) {
      toast("No account found");
      return;
    }
    console.log({ messageString });

    // Loader
    try {
      const message: Message = new Message();
      // const messageAction = new MessageAction();
      // const messageAttachment = new MessageAttachment();
      const messageActions = [];
      const messagettachments = [];

      // messageAction.contract = "";
      // messageAction.abi = "";
      // messageAction.action = "";
      // messageAction.parameters = [""];

      // messageActions.push(messageAction);

      // messageAttachment.cid = "";
      // messageAttachment.hash = "";

      // messagettachments.push(messageAttachment);

      message.topic = TOPIC_ID;
      message.sender = Address.fromString(account);
      message.data = Buffer.from(messageString);
      message.dataType = DataType.JSON;
      message.nonce = Date.now();
      // message.attachments = messagettachments.map((item) => item.asPayload());
      // message.actions = messageActions.map((item) => item.asPayload());

      const payload: ClientPayload<Message> = new ClientPayload();

      payload.chainId = new ChainId(ML_CHAIN_ID);
      payload.data = message;
      payload.timestamp = Date.now();
      payload.eventType = MemberMessageEventType.SendMessageEvent;
      payload.validator = VALIDATOR_PUBLIC_KEY;
      payload.account = Address.fromString(account);
      payload.nonce = 0;

      payload.subnet = SUBNET_ID;
      const pb = payload.encodeBytes();
      console.log("HEXDATA", pb.toString("hex"));
      console.log("PAYLOAOOD", pb);
      payload.signature = await Utils.signMessageEcc(pb, agent.privateKey);
      console.log("Payload::::", payload.data.data);
      console.log("Payload", JSON.stringify(payload.asPayload()));

      const client = new Client(new RESTProvider(NODE_HTTP));
      const resp: any = await client.createMessage(payload);

      const event = resp?.data;

      client.resolveEvent({ type: event?.t, id: event?.id }).then(async (e) => {
        console.log({ e });
        // subscribe
      });
    } catch (e: any) {
      console.log("AUTHORIZE error", e);
      toast(e?.response?.data?.error);
    }
    // Loader
  };


  return (
    <div className="App container-fluid ">
      <ToastContainer />
      <dialog
        open={address && !localAgentRecords?.[`${address}`]?.authData}
        // open={false}
      >
        <article>
          <header>
            <p>
              <strong>Authorize this device</strong>
            </p>
          </header>
          <p>
            You must authorize this device to connect to mlayer's testnet on{" "}
            {address} behalf.
          </p>
          <button
            className="primary"
            style={{ borderRadius: "100px", fontWeight: "bold" }}
            onClick={handleAuth}
          >
            Authorize Device
          </button>
          <button
            className="outline"
            style={{
              borderRadius: "100px",
              marginLeft: 20,
              fontWeight: "bold",
            }}
            onClick={disconnectFn}
          >
            Cancel
          </button>
        </article>
      </dialog>

      <div className="App-header">
        <div style={{ flex: 1, alignContent: "center", textAlign: "left" }}>
         <a href="/" style={{textDecoration: 'none'}}><img
            src="/mLAYER-logo3.png"
            alt="mLayer"
            className="bg-cover mt-0"
            width={150}
          />
          / GAMES</a> 
        </div>
        <div style={{ marginRight: 50, textDecoration: 'none', fontSize: '0.6em' }}>
          <a href="/" style={{ marginRight: 20, textDecoration: 'none',}}>Home</a>  <a href="https://devnet.studio.mlayer.io/airdrop" style={{ marginRight: 20, textDecoration: 'none' }}>Airdrop</a>
          </div>
        {!address && (
          <button
            className="primary"
            style={{ borderRadius: "100px",  fontWeight: "bold" }}
            onClick={connectFn}
          >
            Connect Wallet
          </button>
        )}
        {!!address && (
          <button
            className="outline"
            style={{ borderRadius: "100px" }}
            onClick={disconnectFn}
          >
            {address.substring(0, 6)}...{" "}
            <span style={{ fontWeight: "bold" }}>Disconnect</span>
          </button>
        )}
      </div>
      {address && localAgentRecords?.[`${address}`]?.authData && (
        <div style={{ minHeight: "100vh" }}>{props.children}</div>
      )}
      {/* <div
        id="game"
        style={{
          height: "1000px",
          display: localAgent?.authData ? "block" : "none",
        }}
      ></div> */}
    </div>
  );
}

export default App;
